console.log('[KL] klothos-pdp.js v2.6 loaded');
/**
 * KLOTHOS — PDP Interactividad
 * assets/klothos-pdp.js · v2.6
 *
 * Módulos:
 *   1. HELPERS          — utilidades internas
 *   2. TARJETAS         — selector modalidades de compra (caja / lote 3)
 *   3. MINIATURAS       — galería de imágenes custom
 *   4. COLLAPSIBLES     — acordeón de secciones PDP
 *   5. NAV INTERNA      — navegación por anclas + indicador activo
 *   6. SCROLL REVEAL    — animaciones de entrada PDP
 *   7. PRE-F5           — estado bloqueado coherente
 *   8. INIT             — arranca todo, compatible con Shopify section:load
 *
 * Principios:
 *   · Solo clases CSS — nunca manipulación directa de style
 *   · Defensivo — cada función verifica existencia de nodos
 *   · ARIA compliant — aria-pressed, aria-expanded, aria-selected
 *   · Keyboard accessible — Enter y Space como activadores + flechas en galería
 *   · Re-init seguro — flag en nodo evita listeners duplicados
 *   · Sin dependencias externas
 *   · Coherente con SDM v3: sin urgencias, sin social proof, sin inline style
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────────
     1. HELPERS
  ───────────────────────────────────────────────────────────────────── */

  function $(sel, scope) {
    return (scope || document).querySelector(sel);
  }

  function $$(sel, scope) {
    return Array.from((scope || document).querySelectorAll(sel));
  }

  /**
   * Añade un listener una sola vez usando un flag en el nodo.
   * Evita duplicar handlers en re-inits por Shopify section:load.
   */
  function bindOnce(el, event, handler, key) {
    if (!el || el['_kl_' + key]) return;
    el.addEventListener(event, handler);
    el['_kl_' + key] = true;
  }

  function isPreF5() {
    return document.body.classList.contains('klothos-pre-f5');
  }


  /* ─────────────────────────────────────────────────────────────────────
     2. TARJETAS — selector modalidades de compra
     ─────────────────────────────────────────────────────────────────────
     Estructura HTML esperada:
       <div class="kl-modalidades-grid">
         <div class="kl-tarjeta" data-variant-id="XXXX">
           ...contenido de la tarjeta (precio, dosis, etiqueta)...
         </div>
         <div class="kl-tarjeta" data-variant-id="YYYY">
           ...
         </div>
       </div>

     Decisión A-D092 (SDM v3): ninguna opción está preseleccionada.
     La diferencia de precio es factual y visible, sin énfasis promocional.
  ───────────────────────────────────────────────────────────────────── */

  function klSelectCard(el) {
    if (!el) return;
    var grid = el.closest('.kl-modalidades-grid');
    if (!grid) return;

    // Desactivar todas
    $$('.kl-tarjeta', grid).forEach(function (card) {
      card.classList.remove('kl-tarjeta--activa');
      card.setAttribute('aria-pressed', 'false');
    });

    // Activar la elegida
    el.classList.add('kl-tarjeta--activa');
    el.setAttribute('aria-pressed', 'true');

    // Sincronizar variante Shopify (solo si no estamos en PRE-F5)
    var variantId = el.dataset.variantId;
    if (variantId && !isPreF5()) {
      _syncShopifyVariant(variantId);
    }
  }

  /**
   * Actualiza el input[name="id"] del product form de Dawn
   * para que "Añadir al pedido" envíe la variante correcta.
   */
  function _syncShopifyVariant(variantId) {
    var form = $('form[action*="/cart/add"]');
    var input = form ? $('input[name="id"]', form) : $('input[name="id"]');
    if (!input) return;
    input.value = variantId;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initTarjetas() {
    $$('.kl-tarjeta').forEach(function (card, idx) {
      if (!card.hasAttribute('role'))     card.setAttribute('role', 'button');
      if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');
      if (!card.hasAttribute('aria-pressed')) card.setAttribute('aria-pressed', 'false');

      bindOnce(card, 'click', function () {
        klSelectCard(card);
      }, 'tarjeta_click_' + idx);

      bindOnce(card, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          klSelectCard(card);
        }
      }, 'tarjeta_key_' + idx);
    });
  }


  /* ─────────────────────────────────────────────────────────────────────
     3. MINIATURAS — galería de imágenes custom
     ─────────────────────────────────────────────────────────────────────
     Estructura HTML esperada:
       <div class="kl-galeria">
         <img class="kl-img-principal" src="...">
         <div class="kl-miniaturas-wrap" role="tablist" aria-label="Imágenes del producto">
           <div class="kl-miniatura kl-miniatura--activa"
                data-src="URL_grande"
                data-alt="Descripción"
                role="tab" aria-selected="true" tabindex="0">
             <img src="URL_mini" alt="...">
           </div>
           ...
         </div>
       </div>
  ───────────────────────────────────────────────────────────────────── */

  function initMiniaturas() {
    $$('.kl-miniaturas-wrap').forEach(function (wrap) {
      var minis = $$('.kl-miniatura', wrap);
      if (!minis.length) return;

      // Atributo role en el wrap
      if (!wrap.hasAttribute('role')) wrap.setAttribute('role', 'tablist');

      minis.forEach(function (m, idx) {
        var isActive = m.classList.contains('kl-miniatura--activa');
        m.setAttribute('role', 'tab');
        m.setAttribute('aria-selected', isActive ? 'true' : 'false');
        m.setAttribute('tabindex', isActive ? '0' : '-1');

        bindOnce(m, 'click', function () {
          _activateMiniatura(minis, m, wrap);
        }, 'mini_click_' + idx);

        bindOnce(m, 'keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _activateMiniatura(minis, m, wrap);
            return;
          }
          // Navegación por flechas (tablist pattern)
          var newIdx = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            newIdx = (idx + 1) % minis.length;
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            newIdx = (idx - 1 + minis.length) % minis.length;
          } else if (e.key === 'Home') {
            newIdx = 0;
          } else if (e.key === 'End') {
            newIdx = minis.length - 1;
          }
          if (newIdx >= 0) {
            e.preventDefault();
            _activateMiniatura(minis, minis[newIdx], wrap);
            minis[newIdx].focus();
          }
        }, 'mini_key_' + idx);
      });
    });
  }

  function _activateMiniatura(minis, active, wrap) {
    minis.forEach(function (x) {
      x.classList.remove('kl-miniatura--activa');
      x.setAttribute('aria-selected', 'false');
      x.setAttribute('tabindex', '-1');
    });

    active.classList.add('kl-miniatura--activa');
    active.setAttribute('aria-selected', 'true');
    active.setAttribute('tabindex', '0');

    // Actualizar imagen principal si existe
    var galeria   = wrap.closest('.kl-galeria');
    var mainImg   = galeria ? $('.kl-img-principal', galeria) : null;
    var src       = active.dataset.src || active.dataset.imgSrc;
    if (mainImg && src) {
      mainImg.src = src;
      var miniImg = active.querySelector('img');
      mainImg.alt = active.dataset.alt || (miniImg ? miniImg.alt : '') || '';
    }
  }


  /* ─────────────────────────────────────────────────────────────────────
     4. COLLAPSIBLES — acordeón de secciones PDP
     ─────────────────────────────────────────────────────────────────────
     Estructura HTML esperada (dos patrones):
       A) Custom:
          <div class="kl-expandable">
            <button data-kl-expand aria-expanded="false">Título</button>
            <div class="kl-expandable__body">Contenido</div>
          </div>

       B) Semántico nativo (Dawn):
          <details>
            <summary>Título</summary>
            Contenido
          </details>
          → Ya funciona nativamente. El módulo solo añade clase para CSS.
  ───────────────────────────────────────────────────────────────────── */

  function initCollapsibles() {
    $$('[data-kl-expand]').forEach(function (trigger, idx) {
      var parent = trigger.closest('.kl-expandable, .expandable');
      if (!parent) return;

      var bodyId = 'kl-exp-' + idx;
      var body   = parent.querySelector('.kl-expandable__body, .expandable__body');
      var isOpen = parent.classList.contains('open') || parent.classList.contains('is-open');

      if (body && !body.id) body.id = bodyId;
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (body) trigger.setAttribute('aria-controls', body.id);

      bindOnce(trigger, 'click', function () {
        _toggleCollapsible(trigger, parent);
      }, 'exp_click_' + idx);

      bindOnce(trigger, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          _toggleCollapsible(trigger, parent);
        }
      }, 'exp_key_' + idx);
    });

    // Patrón <details> nativo: añadir clase para CSS transitions si se desea
    $$('details.kl-details').forEach(function (det, idx) {
      bindOnce(det, 'toggle', function () {
        det.classList.toggle('is-open', det.open);
      }, 'details_toggle_' + idx);
    });
  }

  function _toggleCollapsible(trigger, parent) {
    var isOpen = parent.classList.contains('open') || parent.classList.contains('is-open');
    parent.classList.toggle('open', !isOpen);
    parent.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  }


  /* ─────────────────────────────────────────────────────────────────────
     5. NAVEGACIÓN INTERNA — anclas PDP con indicador activo
     ─────────────────────────────────────────────────────────────────────
     Estructura HTML esperada:
       <nav class="kl-nav-interna" aria-label="Secciones">
         <a href="#kl-ingredientes">Fórmula</a>
         <a href="#kl-protocolo">Protocolo</a>
         <a href="#kl-trazabilidad">Trazabilidad</a>
       </nav>
  ───────────────────────────────────────────────────────────────────── */

  function initNavInterna() {
    var nav = $('.kl-nav-interna');
    if (!nav) return;

    var links    = $$('a[href^="#"]', nav);
    var headerH  = _getHeaderH();

    // Smooth scroll con offset de header
    links.forEach(function (link, idx) {
      bindOnce(link, 'click', function (e) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - _getHeaderH() - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 'nav_click_' + idx);
    });

    // Indicador activo via IntersectionObserver
    if (!('IntersectionObserver' in window)) return;

    var sections = links.map(function (l) {
      return document.querySelector(l.getAttribute('href'));
    }).filter(Boolean);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (link) {
          var active = document.querySelector(link.getAttribute('href')) === entry.target;
          link.classList.toggle('is-active', active);
          link.setAttribute('aria-current', active ? 'true' : 'false');
        });
      });
    }, {
      rootMargin: '-' + (_getHeaderH() + 24) + 'px 0px -55% 0px',
      threshold: 0
    });

    sections.forEach(function (sec) { io.observe(sec); });
  }

  function _getHeaderH() {
    var val = getComputedStyle(document.documentElement).getPropertyValue('--kl-header-h');
    return parseInt(val, 10) || 84;
  }


  /* ─────────────────────────────────────────────────────────────────────
     6. SCROLL REVEAL — animaciones de entrada del PDP
     Usa la misma clase .kl-reveal + .is-visible que el resto del sitio.
     Respeta prefers-reduced-motion (WCAG 2.3).
  ───────────────────────────────────────────────────────────────────── */

  function initScrollReveal() {
    var els = $$('.kl-reveal').filter(function (el) {
      return !el.classList.contains('is-visible');
    });
    if (!els.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || reducedMotion) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -28px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }


  /* ─────────────────────────────────────────────────────────────────────
     7. PRE-F5 — coherencia del estado no-comercial
     ─────────────────────────────────────────────────────────────────────
     Principio SDM v3: en PRE-F5 no hay compra activa.
     No se usan mensajes de urgencia ni countdown (prohibido por SDM).
     El botón muestra el label data-pre-f5-label si está definido,
     y se deshabilita funcionalmente sin dramatismo.
  ───────────────────────────────────────────────────────────────────── */

  function initPreF5() {
    if (!isPreF5()) return;

    // Botones de compra
    var buySelectors = [
      '[name="add"]',
      '.kl-btn-compra',
      '.kl-btn--add',
      '[data-kl-buy]'
    ];
    $$(buySelectors.join(',')).forEach(function (btn) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      var preLabel = btn.dataset.preF5Label;
      if (preLabel) {
        // Guardar el label original para posible restauración
        btn.dataset.originalLabel = btn.textContent.trim();
        btn.textContent = preLabel;
      }
    });

    // Las tarjetas siguen siendo seleccionables visualmente
    // (el usuario puede explorar las opciones aunque no pueda comprar)
    // No se bloquea la interacción de selección — solo el cart add.
  }


  /* ─────────────────────────────────────────────────────────────────────
     8. INIT — punto de entrada único
  ───────────────────────────────────────────────────────────────────── */

  function init() {
    // Actuar solo si hay contexto PDP en la página
    var hasPDP = $('[data-product-id]')
      || $('.kl-modalidades-grid')
      || $('.product__info-container');

    if (!hasPDP) return;

    initTarjetas();
    initMiniaturas();
    initCollapsibles();
    initNavInterna();
    initScrollReveal();
    initPreF5();
  }

  // Arranque
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init en Shopify Theme Editor
  document.addEventListener('shopify:section:load',    init);
  document.addEventListener('shopify:section:reorder', init);

  // API pública — klSelectCard se llama desde onclick en HTML del producto
  window.klSelectCard = klSelectCard;


})();

// ─── MÓDULO 9 — EVENT DELEGATION PDP KLOTHOS ──────────
// Galería custom y selector de modalidad via delegación
// para elementos en HTML de descripción del producto
(function() {
  // Exponer klSetImg como función global para onclick inline
  window.klSetImg = function(el) {
    console.log('[KL] klSetImg called', el);
    var principal = document.querySelector('.kl-img-principal');
    if (!principal) { console.warn('[KL] .kl-img-principal NOT found'); return; }
    principal.src = el.dataset.src;
    principal.alt = el.dataset.alt || '';
    document.querySelectorAll('.kl-miniatura').forEach(function(m) {
      m.style.border = '1px solid rgba(26,26,26,0.12)';
    });
    el.style.border = '2px solid #A15F4A';
  };

  // Delegación para miniaturas (fallback si onclick no funciona)
  document.addEventListener('click', function(e) {
    var miniatura = e.target.closest('.kl-miniatura');
    if (!miniatura) return;
    console.log('[KL] miniatura click (delegation)', miniatura);
    window.klSetImg(miniatura);
  });

  // Delegación para tarjetas de modalidad
  document.addEventListener('click', function(e) {
    // ADDENDUM SUBSCRIPTION-NATIVE: excluido en presencia del modulo
    // H5. Este handler legacy escribe ids de variante y plan legacy en
    // #kl-variant-id y #kl-selling-plan; con H5 presente la unica
    // verdad transaccional es assets/kl-pdp-h5.js.
    if (document.getElementById('kl-h5-compra')) return;
    var tarjeta = e.target.closest('.kl-tarjeta');
    if (!tarjeta) return;
    console.log('[KL] tarjeta clicked', tarjeta.id);

    // Desmarcar todas
    document.querySelectorAll('.kl-tarjeta').forEach(function(t) {
      t.style.border = '1px solid rgba(26,26,26,0.1)';
    });

    // Marcar activa
    tarjeta.style.border = '2px solid #A15F4A';

    // Mapeo por ID
    var variantId, sellingPlan;
    if (tarjeta.id === 'kl-card-individual') {
      variantId = '52532303855963';
      sellingPlan = '';
    } else if (tarjeta.id === 'kl-card-sub') {
      variantId = '52592780771675';
      sellingPlan = '694370894171';
    }
    if (!variantId) return;

    // Actualizar input variant
    var vi = document.getElementById('kl-variant-id');
    console.log('[KL] kl-variant-id input:', vi ? 'FOUND' : 'NOT FOUND');
    if (vi) vi.value = variantId;

    // Actualizar selling plan
    var sp = document.getElementById('kl-selling-plan');
    console.log('[KL] kl-selling-plan input:', sp ? 'FOUND' : 'NOT FOUND');
    if (sp) {
      if (sellingPlan) {
        sp.name = 'selling_plan';
        sp.value = sellingPlan;
      } else {
        sp.name = '_selling_plan_disabled';
        sp.value = '';
      }
    }

    // Sincronizar con input nativo de Shopify (buscar en el form KLOTHOS primero, luego Dawn)
    var klForm = document.getElementById('kl-add-to-cart-form');
    console.log('[KL] kl-add-to-cart-form:', klForm ? 'FOUND' : 'NOT FOUND');
    var nativeId = klForm
      ? klForm.querySelector('input[name="id"]')
      : document.querySelector('form[action*="/cart/add"] input[name="id"]');
    console.log('[KL] native input[name="id"]:', nativeId ? 'FOUND (value=' + nativeId.value + ')' : 'NOT FOUND');
    if (nativeId) {
      nativeId.value = variantId;
      nativeId.dispatchEvent(new Event('change', { bubbles: true }));
      console.log('[KL] variant synced to', variantId);
    }
  });
})();
// ─── FIN MÓDULO 9 ──────────────────────────────────────

// ─── MÓDULO 10 v5 — CART ADD · URL REDIRECT ────────────
// Estrategia ultra-simple: redirect a /cart/add?id=X&quantity=1
// Sin fetch, sin FormData, sin capture phase.
// Inyecta onclick directo en los botones via querySelector.
// Fallback: si querySelector falla, usa delegation en bubble.
(function() {
  'use strict';

  // ADDENDUM SUBSCRIPTION-NATIVE: excluido en presencia del modulo H5.
  // Este fallback reconstruye variante, plan y cantidad legacy; el
  // purchase module H5 tiene su propio add-to-cart y es la unica
  // verdad transaccional. Sin H5 opera como hasta hoy.
  if (document.getElementById('kl-h5-compra')) return;

  var VARIANT_MAP = {
    'kl-card-individual': 52532303855963,
    'kl-card-sub':        52592780771675
  };
  var DEFAULT_VARIANT = 52532303855963;
  var SELLING_PLAN_ID = 694370894171;

  function getVariantId() {
    var inp = document.getElementById('kl-variant-id');
    if (inp && inp.value) return inp.value;
    inp = document.querySelector('input[name="id"]');
    if (inp && inp.value && !inp.disabled) return inp.value;
    var card = document.querySelector('.kl-tarjeta--activa, .kl-tarjeta[aria-pressed="true"]');
    if (card && card.id && VARIANT_MAP[card.id]) return VARIANT_MAP[card.id];
    return DEFAULT_VARIANT;
  }

  function getSellingPlan() {
    var sp = document.getElementById('kl-selling-plan');
    if (sp && sp.name === 'selling_plan' && sp.value) return sp.value;
    var card = document.querySelector('.kl-tarjeta--activa, .kl-tarjeta[aria-pressed="true"]');
    if (card && card.id === 'kl-card-sub') return SELLING_PLAN_ID;
    return null;
  }

  // ── Redirect directo — sin fetch, sin AJAX ──
  function goToCart() {
    var vid = getVariantId();
    var url = '/cart/add?id=' + vid + '&quantity=1';
    var sp = getSellingPlan();
    if (sp) url += '&selling_plan=' + sp;
    console.log('[KL] M10v5 → redirect:', url);
    window.location.href = url;
  }

  // ── Inyectar handlers directamente en botones ──
  function initButtons() {
    var buttons = document.querySelectorAll('button');
    var count = 0;
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.disabled) continue;
      var text = (btn.textContent || '').toUpperCase();
      if (text.indexOf('INCORPORAR') === -1) continue;
      // Inyectar onclick directamente
      (function(b) {
        b.onclick = function(e) {
          e.preventDefault();
          if (b.type === 'submit') e.stopPropagation();
          console.log('[KL] M10v5 → onclick fired');
          goToCart();
          return false;
        };
      })(btn);
      count++;
      console.log('[KL] M10v5 → bound button #' + count + ':', btn.id || '(sin id)');
    }

    // También interceptar el form submit por si acaso
    var form = document.getElementById('kl-add-to-cart-form');
    if (form) {
      form.onsubmit = function(e) {
        e.preventDefault();
        console.log('[KL] M10v5 → form onsubmit fired');
        goToCart();
        return false;
      };
      console.log('[KL] M10v5 → form bound');
    }

    console.log('[KL] M10v5 INIT → ' + count + ' botones enganchados');
  }

  // Debug
  window.klAddToCart = goToCart;
  window.klGetVariant = getVariantId;

  // Init: esperar al DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  } else {
    initButtons();
  }
})();
// ─── FIN MÓDULO 10 v5 ──────────────────────────────────